import { socket } from './config';

export default {
  sendPhoneAuthRequest: (phone, type, recaptchaResponse) => {
    const variables = {
      phone,
      type,
      recaptchaResponse,
    };

    const query = {
      message: `mutation($phone: String!, $type: PhoneAuthType!, $recaptchaResponse: String!) {
        sendPhoneAuthRequest(phone: $phone, type: $type, recaptchaResponse: $recaptchaResponse)
      }`,
      variables,
      queryName: 'sendPhoneAuthRequest',
    };
    socket.emit('graphql', query);
  },
  confirmPhoneAuth: (phone, code) => {
    const variables = {
      phone,
      code
    };

    const query = {
      message: `mutation($phone: String!, $code: String!){
        confirmPhoneAuth(phone: $phone, code: $code)
      }`,
      variables,
      queryName: 'phoneAuthConfirm',
    };

    socket.emit('graphql', query);
  },
  getOrdersList: (phone) => {
    const query = JSON.stringify({
      message: `{
          buyerDeliveryOrders (phone: \"${phone}\"){
              orders {
                deliveryOrderId
                createdDate
                deliveryPlanDate
                deliveryChangedPlanDate
                cancelDate
                storageEndDate
                storeSchedule
                status
                deliveryDays
                existsCanceledOrders
              }
          }
      }`,
      queryName: 'orders',
    });
    socket.emit('graphql', query);
  }
};
